import _ from 'lodash'
import { bus, helper } from '@/utils'

export default {
  beforeDestroy () {
    bus.$off('hide-timeline-model')
    bus.$off('show-timeline-model')
  },
  methods: {
    async changeFilterType () {
      this.reset()
      await this.infiniteScrollCallback()
    },
    closePopup () {
      bus.$emit('hide-timeline-model')
    },
    getLogs () {
      this.isLoading = true

      const query = {
        args: JSON.stringify({
          tags: this.tagsFormat(this.target),
          metrics: [
            'from',
            'ip',
            'log',
            'log_type'
          ],
          limit: 20,
          start_time: this.startTime,
          end_time: this.lastLogTime
        })
      }

      return this.$api
        .getLogs(query)
        .then(({ data }) => this.showList(data))
        .catch((error) => {
          helper.showErrorMessage(this, this.component, error)

          this.isLoading = false
          this.lists = []
        })
    },
    infiniteScrollCallback () {
      this.infiniteScrollDisabled = true
      return this.getLogs()
        .then((logs) => {
          if (logs.length) {
            this.infiniteScrollDisabled = false
          }
        })
    },
    reset () {
      this.isLoading = false
      this.isNoMore = false
      this.lastLogTime = undefined
      this.lists = null
    },
    showList ({ columns, values }) {
      this.isLoading = false

      if (_.isEmpty(values)) {
        this.isNoMore = true
      }

      if (!this.lists) {
        this.lists = []
      }

      const logs = values.map(value => {
        const item = _.zipObject(columns, value)
        let action

        try {
          action = JSON.parse(item.log)
        } catch (error) {
          helper.showErrorMessage(this, this.component, error)
          action = {}
        }

        return {
          action,
          from: item.from,
          ip: item.ip,
          type: item.log_type,
          status: this.viewLogInfo(item.status),
          time: item.time,
          identity: this.target
        }
      })

      this.lists = this.lists.concat(logs)

      const lastLog = _.last(this.lists)
      this.lastLogTime = _.has(lastLog, 'time')
        ? new Date(lastLog.time).toJSON()
        : ''

      return logs
    },
    tagsFormat (target) {
      if (_.includes(target, '@')) {
        return { email: target, log_type: 'event' }
      }
      return this.filterType === 'all' ? { device_unique_id: target } : { device_unique_id: target, log_type: this.filterType }
    },
    viewLogInfo (status) {
      let data = {}
      _.forEach(
        status,
        (value, key) => { data = Object.assign({}, data, { [key]: value }) }
      )

      return data
    }
  },
  name: 'TimelineModel',
  props: {
    fields: {
      type: Array,
      default: () => []
    },
    showEventFilter: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      component: 'timelineModel',
      dialogProps: {
        beforeClose: () => this.closePopup(),
        width: '70%'
      },
      headerSelectFilter: [
        {
          text: 'timelineFilterLabelAllText',
          dataQA: 'Dialog-TimelineModel-Filter-Option-All',
          value: 'all'
        },
        {
          text: 'timelineFilterLabelErrorText',
          dataQA: 'Dialog-TimelineModel-Filter-Option-Error',
          value: 'error'
        },
        {
          text: 'timelineFilterLabelDebugText',
          dataQA: 'Dialog-TimelineModel-Filter-Option-Debug',
          value: 'debug'
        }
      ],
      filterType: 'all',
      infiniteScrollDisabled: false,
      isLoading: false,
      isNoMore: false,
      lastLogTime: undefined,
      lists: null,
      showModal: false,
      startTime: helper.parseStartTime(this.$store.state.dataRetention)
    }
  },
  mounted () {
    bus.$on('show-timeline-model', data => {
      this.showModal = true
      this.filterType = 'all'
      this.reset()

      Object.assign(this, _.pick(data, ['target']))

      this.infiniteScrollCallback()
    })

    bus.$on('hide-timeline-model', () => {
      this.showModal = false
    })

    if (!this.showModal) {
      this.infiniteScrollDisabled = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/TimelineModel/TimelineModel.js